export const SUCCESS_MANGMENT_ACCOUNT="SUCCESS_MANGMENT_ACCOUNT";
export const FAILED_MANGMENT_ACCOUNT="FAILED_MANGMENT_ACCOUNT";
export const REQUST_MANGMENT_ACCOUNT="REQUST_MANGMENT_ACCOUNT";
